import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LoginPage from "../../pages/LoginPage";
import ResetPasswordPage from "../../pages/ResetPasswordPage";
import AppHelpPage from "../../pages/AppHelpPage";
import TodayAppointmentPage from "../../pages/TodayAppointmentPage";
import UpcomingAppointmentPage from "../../pages/UpcomingAppointmentPage";
import HistoryAppointmentPage from "../../pages/HistoryAppointmentPage";
import PatientInfo from "../../pages/PatientInfo";
import DoctorSessionsPage from "../../pages/DoctorSessionsPage";
import { Chat } from "@material-ui/icons";
import { ChatPage } from "../../pages/ChatPage";
import PrescriptionUpload from "../../pages/PrescriptionUpload";
import InvoiceSummaryPage from "../../pages/InvoiceSummaryPage";
import ServiceMasterPage from "../../pages/ServiceMasterPage";

const appRoutes = [
  {
    path: "/dashboard",
    component: DoctorSessionsPage,
  },
  {
    path: "/",
    component: LoginPage,
  },
  {
    path: "/reset-password",
    component: ResetPasswordPage,
  },
  {
    path: "/app-help",
    component: AppHelpPage,
  },
  {
    path: "/today-appointment",
    component: TodayAppointmentPage,
  },
  {
    path: "/upcoming-appointment",
    component: UpcomingAppointmentPage,
  },
  {
    path: "/history-appointment",
    component: HistoryAppointmentPage,
  },
  {
    path: "/patient-info",
    component: PatientInfo,
  },
  {
    path: "/chat",
    component: ChatPage,
  },
  {
    path: "/prescription-upload",
    component: PrescriptionUpload,
  },
  {
    path: "/invoice-summary",
    component: InvoiceSummaryPage,
  },
  {
    path: "/service-master",
    component: ServiceMasterPage,
  },
];

export default function AppRoutes() {
  return (
    <Router>
      <Routes>
        {appRoutes.map((route, i) => (
          <Route key={i} path={route.path} element={<route.component />} />
        ))}
      </Routes>
    </Router>
  );
}
